import { cn } from '@/lib/utils';

import LinkButtonSB, {
  LinkButtonSBProps,
} from '@/components/atoms/linkButton/LinkSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';

import {
  BlockHeader,
  BlockHeaderContent,
} from '@/features/utils/BlockHeaderContent';
import { BlockWrapper } from '@/features/utils/BlockWrapper';

export interface CTABlockProps {
  header?: BlockHeader;
  link: LinkButtonSBProps;
}

export function CTABlockStrapi({
  block,
  ...rest
}: BlockComponentModel<CTABlockProps>) {
  const { link, header } = block;

  return (
    <BlockWrapper {...rest}>
      <div data-tracker-section={SECTION_NAMES.CTA_BLOCK}>
        <BlockHeaderContent
          {...header}
          classNames={{
            button: cn(!header?.title && !header?.subtitle && '!mt-0'),
          }}
          renderButtons={
            link
              ? [
                  (props) => (
                    <LinkButtonSB
                      block={link}
                      key={link.text + 'cta-block-strapi'}
                      inner={{
                        ...props,
                      }}
                    />
                  ),
                ]
              : undefined
          }
        />
      </div>
    </BlockWrapper>
  );
}
